import React, { useState } from "react";
import { Button } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export default function CopyUrlButton({
  label = "Copy Link",
  link = window.location.href,
  variant = "outlined",
  subLink,
  sx,
}) {
  const [copied, setCopied] = useState(false);

  const url = subLink ? window.location.origin + subLink : link;

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 4000);
    } catch (error) {
      console.error("Failed to copy URL:", error);
    }
  };

  return (
    <>
      <Button
        variant={variant}
        color={copied ? "success" : "primary"}
        onClick={handleCopyUrl}
        startIcon={copied ? <CheckCircleOutlineIcon /> : <LinkIcon />}
        sx={{ textTransform: "none", ...sx }}
      >
        {copied ? "Copied!" : label}
      </Button>
    </>
  );
}
